import type { PropsWithChildren } from 'react';
import React from 'react';
import cx from 'classnames';

import { Modal } from '@motorway/motorway-storybook-cra';
import { VRM } from '@motorway/mw-highway-code/alpha';

import cypressIds from 'Components/cypress_ids.json';
import ModalFooter from 'Components/Modal/Footer/ModalFooter';
import type { ModalHeaderProps } from 'Components/Modal/Header/ModalHeader';
import ModalHeader from 'Components/Modal/Header/ModalHeader';
import type { Vehicle } from 'Types/vehicle';
import { applyCypressData } from 'Utilities/helpers';

import styles from './VrmModal.module.scss';

type VrmModalProps = ModalHeaderProps &
	Pick<Vehicle, 'vrm'> & {
		footer?: React.ReactNode;
		makeModel: string;
		makeModelStyle?: string;
		onDismissModal?: () => void;
		subtitle?: React.ReactNode;
	};

const VrmModal: React.FC<PropsWithChildren<VrmModalProps>> = ({
	children,
	footer,
	makeModel,
	makeModelStyle,
	onDismissModal,
	subtitle,
	title,
	vrm,
}) => (
	<Modal className={styles.vrmModal} dismissModal={onDismissModal} size="small">
		<ModalHeader title={title} />
		<section className={styles.vrm}>
			<VRM size="regular" text={vrm} />
		</section>
		<section className={cx(styles.makeModel, makeModelStyle)}>
			<p>{makeModel}</p>
		</section>
		{subtitle ? (
			<section className={styles.subtitle}>
				<p>{subtitle}</p>
			</section>
		) : null}
		<section className={styles.content} {...applyCypressData(cypressIds.tables.motModal)}>
			{children}
		</section>

		{footer && <ModalFooter>{footer}</ModalFooter>}
	</Modal>
);

export default VrmModal;
